export default __webpack_public_path__ + "static/media/logo.d6c6a883.svg";